module.exports = __webpack_public_path__ + "img/fabu.f6f6967.png";